// Portfolio projects data with case studies organized by industry categories
// Categories: Sports, Vehicles, Lifestyle, Commercial, Music, Creative
// Direct video files from Bankki Media

export const categories = [
  { id: 'all', name: 'All', icon: '🎬' },
  { id: 'sports', name: 'Sports', icon: '⚽' },
  { id: 'vehicles', name: 'Vehicles', icon: '🏎️' },
  { id: 'lifestyle', name: 'Lifestyle', icon: '✨' },
  { id: 'music', name: 'Music', icon: '🎵' },
  { id: 'commercial', name: 'Commercial', icon: '☕' },
];

export const projects = [
  // ============ SPORTS CATEGORY ============
  {
    id: 'wnba-ovo',
    title: 'WNBA x OVO',
    category: 'sports',
    categoryLabel: 'Sports',
    shortDescription: 'OVO x WNBA partnership campaign',
    description: 'A powerful campaign celebrating the partnership between OVO and the WNBA, highlighting the rise of women\'s basketball culture.',
    image: 'https://images.unsplash.com/photo-1546519638-68e109498ffc?w=800&h=600&fit=crop',
    heroImage: 'https://images.unsplash.com/photo-1546519638-68e109498ffc?w=1600&h=900&fit=crop',
    year: '2024',
    client: 'OVO x WNBA',
    industry: 'Basketball / Fashion',
    services: ['Commercial Production', 'Brand Campaign', 'Social Content'],
    videoUrl: 'https://customer-assets.emergentagent.com/job_a74420e0-6f5b-4599-9a2c-420456c6e3dd/artifacts/i3qlcmip_wnba_x_ovo_v2%20%281080p%29.mp4',
    results: [
      { metric: '15M+', label: 'Total views' },
      { metric: '#1', label: 'Trending sports content' },
      { metric: '200%', label: 'Engagement vs benchmark' },
    ],
    featured: true,
  },
  {
    id: 'ufc-gsp',
    title: 'Georges Saint-Pierre for UFC x OVO',
    category: 'sports',
    categoryLabel: 'Sports',
    shortDescription: 'UFC legend GSP for OVO collaboration',
    description: 'An iconic commercial featuring MMA legend Georges Saint-Pierre for the UFC x OVO collaboration, celebrating combat sports culture.',
    image: 'https://images.unsplash.com/photo-1549719386-74dfcbf7dbed?w=800&h=600&fit=crop',
    heroImage: 'https://images.unsplash.com/photo-1549719386-74dfcbf7dbed?w=1600&h=900&fit=crop',
    year: '2024',
    client: 'UFC x OVO',
    industry: 'Combat Sports / Fashion',
    services: ['Commercial Production', 'Documentary Style', 'Brand Film'],
    videoUrl: 'https://customer-assets.emergentagent.com/job_a74420e0-6f5b-4599-9a2c-420456c6e3dd/artifacts/uvfbhmv8_georges_saint-pierre_for_ufc_x_ovo_v1%20%281080p%29.mp4',
    results: [
      { metric: '20M+', label: 'Video views' },
      { metric: 'Viral', label: 'Social media status' },
      { metric: '98%', label: 'Positive sentiment' },
    ],
    featured: true,
  },
  {
    id: 'ovo-sheerwood',
    title: 'OVO x SHEERWOOD',
    category: 'sports',
    categoryLabel: 'Sports',
    shortDescription: 'OVO x Sheerwood hockey collaboration',
    description: 'A cinematic campaign for the OVO x Sheerwood collaboration, blending hockey heritage with streetwear culture.',
    image: 'https://customer-assets.emergentagent.com/job_a74420e0-6f5b-4599-9a2c-420456c6e3dd/artifacts/a41gjiso_Screenshot%202026-02-22%20140915.png',
    heroImage: 'https://customer-assets.emergentagent.com/job_a74420e0-6f5b-4599-9a2c-420456c6e3dd/artifacts/a41gjiso_Screenshot%202026-02-22%20140915.png',
    year: '2024',
    client: 'OVO x Sheerwood',
    industry: 'Hockey / Fashion',
    services: ['Commercial Production', 'Brand Campaign', 'Cinematography'],
    videoUrl: 'https://customer-assets.emergentagent.com/job_a74420e0-6f5b-4599-9a2c-420456c6e3dd/artifacts/62tcjtz6_ovo_x_sheerwood_v1%20%281440p%29.mp4',
    results: [
      { metric: '10M+', label: 'Campaign reach' },
      { metric: 'Sold Out', label: 'Collection status' },
      { metric: '300%', label: 'Social engagement' },
    ],
    featured: true,
  },
  {
    id: 'ovo-campus',
    title: 'OVO CAMPUS',
    category: 'sports',
    categoryLabel: 'Sports',
    shortDescription: 'OVO Basketball Campus documentary',
    description: 'An intimate look at the OVO Campus basketball program, showcasing the next generation of talent and the culture that defines OVO.',
    image: 'https://customer-assets.emergentagent.com/job_a74420e0-6f5b-4599-9a2c-420456c6e3dd/artifacts/3zkv5zw1_Screenshot%202026-02-22%20143911.png',
    heroImage: 'https://customer-assets.emergentagent.com/job_a74420e0-6f5b-4599-9a2c-420456c6e3dd/artifacts/3zkv5zw1_Screenshot%202026-02-22%20143911.png',
    year: '2024',
    client: 'OVO',
    industry: 'Basketball / Culture',
    services: ['Documentary Production', 'Brand Film', 'Cinematography'],
    videoUrl: 'https://customer-assets.emergentagent.com/job_a74420e0-6f5b-4599-9a2c-420456c6e3dd/artifacts/9wljlt8g_ovo_campus_v1%20%281080p%29.mp4',
    results: [
      { metric: '8M+', label: 'Total views' },
      { metric: 'Cultural', label: 'Impact' },
      { metric: 'Authentic', label: 'Storytelling' },
    ],
    featured: false,
  },
  {
    id: 'good-food-nick-suzuki',
    title: 'GOOD FOOD x NICK SUZUKI',
    category: 'sports',
    categoryLabel: 'Sports',
    shortDescription: 'Good Food featuring NHL star Nick Suzuki',
    description: 'A commercial featuring Montreal Canadiens captain Nick Suzuki, showcasing the intersection of elite athletics and healthy living.',
    image: 'https://images.unsplash.com/photo-1515703407324-5f753afd8be8?w=800&h=600&fit=crop',
    heroImage: 'https://images.unsplash.com/photo-1515703407324-5f753afd8be8?w=1600&h=900&fit=crop',
    year: '2024',
    client: 'Good Food',
    industry: 'Hockey / Lifestyle',
    services: ['Commercial Production', 'Brand Campaign', 'Talent Management'],
    videoUrl: 'https://customer-assets.emergentagent.com/job_a74420e0-6f5b-4599-9a2c-420456c6e3dd/artifacts/6vo4hbav_good_food_x_nick_suzuki%20%281080p%29.mp4',
    results: [
      { metric: '5M+', label: 'Campaign reach' },
      { metric: '35%', label: 'Brand awareness lift' },
      { metric: 'Authentic', label: 'Partnership' },
    ],
    featured: false,
  },

  // ============ MUSIC CATEGORY ============
  {
    id: 'central-cee-chelsea-ovo',
    title: 'CENTRAL CEE for OVO x CHELSEA',
    category: 'music',
    categoryLabel: 'Music',
    shortDescription: 'Central Cee x Chelsea FC x OVO collaboration',
    description: 'An exclusive commercial featuring Central Cee for the OVO x Chelsea FC collaboration, blending street culture, music, and football heritage.',
    image: 'https://images.unsplash.com/photo-1522778119026-d647f0596c20?w=800&h=600&fit=crop',
    heroImage: 'https://images.unsplash.com/photo-1522778119026-d647f0596c20?w=1600&h=900&fit=crop',
    year: '2024',
    client: 'OVO x Chelsea FC',
    industry: 'Music / Football / Fashion',
    services: ['Commercial Production', 'Music Video', 'Brand Film', 'Post-Production'],
    videoUrl: 'https://customer-assets.emergentagent.com/job_a74420e0-6f5b-4599-9a2c-420456c6e3dd/artifacts/xmj9nei0_central_cee_for_ovo_x_chelsea_v1%20%281080p%29.mp4',
    results: [
      { metric: '28M', label: 'Campaign reach' },
      { metric: '340%', label: 'Engagement increase' },
      { metric: 'Sold Out', label: 'Collection status' },
    ],
    featured: true,
  },

  // ============ VEHICLES CATEGORY ============
  {
    id: 'mclaren-puma',
    title: 'McLAREN x PUMA',
    category: 'vehicles',
    categoryLabel: 'Vehicles',
    shortDescription: 'McLaren F1 x PUMA motorsport collaboration',
    description: 'A stunning showcase of the McLaren F1 team and PUMA partnership, capturing the precision engineering and style that defines modern motorsport.',
    image: 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=800&h=600&fit=crop',
    heroImage: 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=1600&h=900&fit=crop',
    year: '2024',
    client: 'McLaren x PUMA',
    industry: 'Motorsports / Fashion',
    services: ['Commercial Production', 'Cinematography', 'Color Grading', 'VFX'],
    videoUrl: 'https://customer-assets.emergentagent.com/job_a74420e0-6f5b-4599-9a2c-420456c6e3dd/artifacts/f3zadmx5_mc_laren_x_puma_v1%20%281080p%29.mp4',
    results: [
      { metric: '22M', label: 'Video views across platforms' },
      { metric: '18%', label: 'Increase in merchandise sales' },
      { metric: '5', label: 'Industry awards won' },
    ],
    featured: true,
  },
  {
    id: 'honda-lou-pascal',
    title: 'HONDA x LOU PASCAL',
    category: 'vehicles',
    categoryLabel: 'Vehicles',
    shortDescription: 'Honda commercial featuring Lou Pascal',
    description: 'A stylish commercial for Honda featuring Lou Pascal, showcasing the intersection of automotive excellence and personal expression.',
    image: 'https://images.unsplash.com/photo-1606016159991-dfe4f2746ad5?w=800&h=600&fit=crop',
    heroImage: 'https://images.unsplash.com/photo-1606016159991-dfe4f2746ad5?w=1600&h=900&fit=crop',
    year: '2024',
    client: 'Honda',
    industry: 'Automotive',
    services: ['Commercial Production', 'Lifestyle Content', 'Brand Film'],
    videoUrl: 'https://customer-assets.emergentagent.com/job_a74420e0-6f5b-4599-9a2c-420456c6e3dd/artifacts/7c3tyyt2_honda_x_lou_pascal_v1%20%281080p%29.mp4',
    results: [
      { metric: '12M', label: 'Campaign reach' },
      { metric: '25%', label: 'Brand consideration lift' },
      { metric: '4.5/5', label: 'Audience rating' },
    ],
    featured: true,
  },
  {
    id: 'auclair',
    title: 'AUCLAIR',
    category: 'vehicles',
    categoryLabel: 'Vehicles',
    shortDescription: 'Winter sports and outdoor brand film',
    description: 'A cinematic brand film for AUCLAIR, capturing the thrill of winter adventure and the gear that makes it possible.',
    image: 'https://images.unsplash.com/photo-1551524164-687a55dd1126?w=800&h=600&fit=crop',
    heroImage: 'https://images.unsplash.com/photo-1551524164-687a55dd1126?w=1600&h=900&fit=crop',
    year: '2024',
    client: 'AUCLAIR',
    industry: 'Winter Sports / Outdoor',
    services: ['Brand Film', 'Action Cinematography', 'Post-Production'],
    videoUrl: 'https://customer-assets.emergentagent.com/job_a74420e0-6f5b-4599-9a2c-420456c6e3dd/artifacts/gw0do7vd_auclair_v1%20%282160p%29.mp4',
    results: [
      { metric: '8M+', label: 'Total views' },
      { metric: '45%', label: 'Website traffic increase' },
      { metric: '3x', label: 'Social following growth' },
    ],
    featured: false,
  },

  // ============ LIFESTYLE CATEGORY ============
  {
    id: 'dime-eastpak',
    title: 'DIME x EASTPAK',
    category: 'lifestyle',
    categoryLabel: 'Lifestyle',
    shortDescription: 'Streetwear collaboration campaign',
    description: 'A vibrant commercial for the DIME x EASTPAK collaboration, celebrating street culture and functional fashion.',
    image: 'https://images.unsplash.com/photo-1556906781-9a412961c28c?w=800&h=600&fit=crop',
    heroImage: 'https://images.unsplash.com/photo-1556906781-9a412961c28c?w=1600&h=900&fit=crop',
    year: '2024',
    client: 'DIME x EASTPAK',
    industry: 'Streetwear / Fashion',
    services: ['Commercial Production', 'Lookbook', 'Social Content'],
    videoUrl: 'https://customer-assets.emergentagent.com/job_a74420e0-6f5b-4599-9a2c-420456c6e3dd/artifacts/8d56awbm_dime_x_eastpak_v1%20%282160p%29.mp4',
    results: [
      { metric: 'Sold Out', label: 'Collection status' },
      { metric: '150M+', label: 'Total impressions' },
      { metric: '25+', label: 'Press features' },
    ],
    featured: true,
  },
  {
    id: 'dime-merrell',
    title: 'DIME x MERRELL',
    category: 'lifestyle',
    categoryLabel: 'Lifestyle',
    shortDescription: 'Streetwear meets outdoor footwear',
    description: 'A creative campaign for the DIME x MERRELL collaboration, blending skateboard culture with outdoor adventure.',
    image: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=800&h=600&fit=crop',
    heroImage: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=1600&h=900&fit=crop',
    year: '2024',
    client: 'DIME x MERRELL',
    industry: 'Streetwear / Outdoor',
    services: ['Commercial Production', 'Brand Campaign', 'Social Content'],
    videoUrl: 'https://customer-assets.emergentagent.com/job_a74420e0-6f5b-4599-9a2c-420456c6e3dd/artifacts/v11bty2g_dime_x_merrell_v1%20%282160p%29.mp4',
    results: [
      { metric: '10M+', label: 'Total views' },
      { metric: 'Sold Out', label: 'Collection status' },
      { metric: 'Viral', label: 'Social impact' },
    ],
    featured: false,
  },
  {
    id: 'gelcare',
    title: 'GELCARE',
    category: 'lifestyle',
    categoryLabel: 'Lifestyle',
    shortDescription: 'Premium hair care brand film',
    description: 'An elegant brand film for Gelcare, showcasing premium hair care products with a focus on natural beauty and self-expression.',
    image: 'https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?w=800&h=600&fit=crop',
    heroImage: 'https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?w=1600&h=900&fit=crop',
    year: '2024',
    client: 'Gelcare',
    industry: 'Beauty / Hair Care',
    services: ['Brand Film', 'Product Showcase', 'Cinematography'],
    videoUrl: 'https://customer-assets.emergentagent.com/job_a74420e0-6f5b-4599-9a2c-420456c6e3dd/artifacts/nntm5pyk_gelcare_v13%20%282160p%29.mp4',
    results: [
      { metric: '6M+', label: 'Campaign reach' },
      { metric: '40%', label: 'Sales increase' },
      { metric: 'Premium', label: 'Brand positioning' },
    ],
    featured: false,
  },
  {
    id: 'rudsak',
    title: 'RUDSAK',
    category: 'lifestyle',
    categoryLabel: 'Lifestyle',
    shortDescription: 'Luxury outerwear brand campaign',
    description: 'A sophisticated brand film for RUDSAK, showcasing Canadian luxury outerwear with timeless elegance.',
    image: 'https://images.unsplash.com/photo-1539533018447-63fcce2678e3?w=800&h=600&fit=crop',
    heroImage: 'https://images.unsplash.com/photo-1539533018447-63fcce2678e3?w=1600&h=900&fit=crop',
    year: '2024',
    client: 'RUDSAK',
    industry: 'Fashion / Luxury',
    services: ['Brand Film', 'Fashion Campaign', 'Cinematography'],
    videoUrl: 'https://customer-assets.emergentagent.com/job_a74420e0-6f5b-4599-9a2c-420456c6e3dd/artifacts/866el3yz_rudsak%20%281080p%29.mp4',
    results: [
      { metric: '7M+', label: 'Total views' },
      { metric: 'Luxury', label: 'Brand positioning' },
      { metric: '50%', label: 'E-commerce growth' },
    ],
    featured: false,
  },

  // ============ COMMERCIAL CATEGORY ============
  {
    id: 'nespresso-lou-pascal',
    title: 'NESPRESSO x LOU-PASCAL TREMBLAY',
    category: 'commercial',
    categoryLabel: 'Commercial',
    shortDescription: 'Nespresso commercial with Lou-Pascal Tremblay',
    description: 'An elegant commercial for Nespresso featuring Lou-Pascal Tremblay, celebrating the ritual of exceptional coffee.',
    image: 'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=800&h=600&fit=crop',
    heroImage: 'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=1600&h=900&fit=crop',
    year: '2024',
    client: 'Nespresso',
    industry: 'Food & Beverage',
    services: ['Commercial Production', 'Brand Film', 'Cinematography'],
    videoUrl: 'https://customer-assets.emergentagent.com/job_a74420e0-6f5b-4599-9a2c-420456c6e3dd/artifacts/5l79w780_nespresso_x_lou-pascal_tremblay%20%281080p%29.mp4',
    results: [
      { metric: '15M+', label: 'Campaign reach' },
      { metric: '25%', label: 'Brand consideration' },
      { metric: 'Premium', label: 'Brand alignment' },
    ],
    featured: true,
  },
  {
    id: 'line-of-sight',
    title: 'LINE OF SIGHT',
    category: 'commercial',
    categoryLabel: 'Commercial',
    shortDescription: 'Creative documentary short',
    description: 'A visually stunning creative piece exploring perspective, vision, and the art of seeing the world differently.',
    image: 'https://images.unsplash.com/photo-1536440136628-849c177e76a1?w=800&h=600&fit=crop',
    heroImage: 'https://images.unsplash.com/photo-1536440136628-849c177e76a1?w=1600&h=900&fit=crop',
    year: '2024',
    client: 'Original Production',
    industry: 'Creative / Documentary',
    services: ['Documentary Production', 'Cinematography', 'Creative Direction'],
    videoUrl: 'https://customer-assets.emergentagent.com/job_a74420e0-6f5b-4599-9a2c-420456c6e3dd/artifacts/zxw6y7cd_line_of_sight_v1%20%281080p%29.mp4',
    results: [
      { metric: 'Film Festival', label: 'Selection' },
      { metric: 'Cinematic', label: 'Quality' },
      { metric: 'Award', label: 'Winning' },
    ],
    featured: false,
  },
];

// Blog posts data
export const blogPosts = [
  {
    id: 'future-of-content',
    title: 'The Future of Sports Content: Beyond Traditional Broadcasting',
    excerpt: 'How sports organizations are leveraging new media to connect with fans in unprecedented ways.',
    content: `
# The Future of Sports Content: Beyond Traditional Broadcasting

The landscape of sports content is undergoing a radical transformation. As traditional broadcasting models face disruption, innovative content strategies are emerging that bring fans closer to the action than ever before.

## The Rise of Behind-the-Scenes Content

Gone are the days when fans were satisfied with match highlights alone. Today's audiences crave authentic, behind-the-scenes access to their favorite teams and athletes.

**Key trends we're seeing:**
- Documentary series that follow teams throughout entire seasons
- Player-driven content on social platforms
- Real-time content during events and matches

## Social Media as Primary Distribution

Social platforms have become the primary way younger fans consume sports content. Clubs and leagues that understand this shift are building direct relationships with their audiences.

## What This Means for Brands

Brands partnering with sports properties need to think beyond logo placement. The opportunity lies in creating content that genuinely adds value to the fan experience.

## Looking Ahead

The sports organizations that will thrive are those that embrace their role as media companies, producing content that matches the passion of their fanbases.
    `,
    image: 'https://customer-assets.emergentagent.com/job_4c9ec105-7961-43e0-9222-2e0dd1f1cf63/artifacts/e8z56xcn_Screenshot%202026-02-22%20135701.png',
    category: 'Sports',
    author: {
      name: 'James Wilson',
      role: 'Creative Director',
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop',
    },
    publishedAt: '2024-03-15',
    readTime: '5 min read',
    featured: true,
  },
  {
    id: 'automotive-storytelling',
    title: 'The Art of Automotive Storytelling',
    excerpt: 'Why the best car commercials sell feelings, not features.',
    content: `
# The Art of Automotive Storytelling

In a world where car specifications are easily comparable online, the most successful automotive campaigns don't sell features – they sell feelings.

## Beyond Horsepower

The days of listing 0-60 times and engine specs are numbered. Today's car buyers, especially younger generations, care more about how a vehicle fits into their lifestyle.

## Creating Emotional Connection

The best automotive content creates scenarios that viewers can imagine themselves in:
- The open road representing freedom
- The family car representing safety and belonging
- The sports car representing aspiration and success

## The Rise of EV Storytelling

Electric vehicles have introduced new narrative opportunities. Sustainability, innovation, and the future are powerful themes that resonate with conscious consumers.

## Our Approach

At Bankki Media, we believe every vehicle has a story. Our job is to find the emotional truth of each brand and communicate it in ways that move people to action.
    `,
    image: 'https://customer-assets.emergentagent.com/job_4c9ec105-7961-43e0-9222-2e0dd1f1cf63/artifacts/a26ptxru_Screenshot%202026-02-22%20135832.png',
    category: 'Vehicles',
    author: {
      name: 'Sarah Chen',
      role: 'Executive Producer',
      avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop',
    },
    publishedAt: '2024-03-10',
    readTime: '6 min read',
    featured: true,
  },
  {
    id: 'content-production-2024',
    title: 'Inside Our Creative Process: From Brief to Broadcast',
    excerpt: 'A behind-the-scenes look at how we approach world-class content production.',
    content: `
# Inside Our Creative Process: From Brief to Broadcast

Creating world-class content for global brands requires more than creativity – it demands process, precision, and passion. Here's how we approach every project at Bankki Media.

## Phase 1: Deep Discovery

Before we write a single creative brief, we immerse ourselves in our client's world:
- Stakeholder interviews across departments
- Competitive landscape analysis
- Audience research and insights
- Brand archaeology – understanding history and heritage

## Phase 2: Strategic Foundation

With insights in hand, we build the strategic framework:
- Core message development
- Visual language definition
- Distribution strategy
- Success metrics

## Phase 3: Creative Development

This is where ideas come to life:
- Concepting sessions with our full creative team
- Script development and iteration
- Pre-visualization and storyboarding
- Location scouting and casting

## Phase 4: Production Excellence

Our production process is built for both quality and efficiency:
- State-of-the-art equipment and techniques
- Experienced crews from around the world
- Real-time client collaboration
- Rigorous quality control

## Phase 5: Post-Production Magic

Where raw footage becomes finished content:
- Editorial that serves the story
- Color grading that creates mood
- Sound design that enhances emotion
- VFX when the story demands it

## The Bankki Difference

What sets us apart is our refusal to compromise. Every frame, every cut, every sound choice is intentional. We believe our clients and their audiences deserve nothing less.
    `,
    image: 'https://customer-assets.emergentagent.com/job_4c9ec105-7961-43e0-9222-2e0dd1f1cf63/artifacts/ck133v9o_Screenshot%202026-02-22%20135808.png',
    category: 'Agency',
    author: {
      name: 'Marcus Rivera',
      role: 'Head of Production',
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop',
    },
    publishedAt: '2024-03-05',
    readTime: '8 min read',
    featured: true,
  },
  {
    id: 'fashion-content-evolution',
    title: 'How Fashion Content is Evolving in the Digital Age',
    excerpt: 'From runway to TikTok: the transformation of fashion marketing.',
    content: `
# How Fashion Content is Evolving in the Digital Age

The fashion industry has always been at the forefront of visual storytelling. But the digital age has fundamentally changed how brands connect with their audiences.

## The Democratization of Fashion

Social media has broken down the barriers between fashion houses and consumers. Everyone now has front-row access to shows, behind-the-scenes content, and direct communication with brands.

## Speed as a Strategy

The traditional fashion calendar is being disrupted by "see now, buy now" models. Content production needs to match this pace while maintaining quality.

## Authenticity Over Perfection

Today's audiences, especially Gen-Z, respond better to authentic, relatable content than perfectly polished imagery. This shift requires new creative approaches.

## The Role of Creators

Influencers and content creators have become essential partners for fashion brands. The most successful collaborations feel genuine rather than transactional.

## Our Fashion Practice

We've built a dedicated fashion practice that understands both the heritage of luxury houses and the demands of digital-first marketing.
    `,
    image: 'https://customer-assets.emergentagent.com/job_4c9ec105-7961-43e0-9222-2e0dd1f1cf63/artifacts/h7ha2ghf_Screenshot%202026-02-22%20135854.png',
    category: 'Lifestyle',
    author: {
      name: 'Emma Thompson',
      role: 'Fashion Director',
      avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop',
    },
    publishedAt: '2024-02-28',
    readTime: '5 min read',
    featured: false,
  },
];

// Helper functions
export const getProjectById = (id) => projects.find(p => p.id === id);
export const getBlogPostById = (id) => blogPosts.find(p => p.id === id);
export const getFeaturedProjects = () => projects.filter(p => p.featured);
export const getFeaturedPosts = () => blogPosts.filter(p => p.featured);
export const getProjectsByCategory = (category) => {
  if (category === 'all') return projects;
  return projects.filter(p => p.category === category);
};
export const getCategoryById = (id) => categories.find(c => c.id === id);
